var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{staticClass:"side-menu",attrs:{"collapse":_vm.collapse,"default-active":_vm.defaultActive,"menus":_vm.menus,"router":"","background-color":_vm.theme.backgroundColor,"text-color":_vm.theme.textColor,"active-text-color":_vm.theme.activeTextColor}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a2a6930","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/app-side.vue
// module id = 2xyp
// module chunks = 90